import { TagListEditor } from "./TagListEditor";

export function TaxonomyPanel({ settings, setSettings, isAdmin, onRename }) {
  const renameFor = (listKey) => onRename ? ((from, to) => onRename(listKey, from, to)) : undefined;
  return (
    <div className="hairline rounded-lg p-5 bg-white" data-testid="settings-taxonomy">
      <div className="font-heading font-semibold">Ticket taxonomy</div>
      <p className="text-xs text-slate-500 mt-1">
        Configure the lists that agents pick from on every ticket. AI classification uses these values too. Rename a value with the pencil icon — renames cascade to every ticket that uses it.
      </p>
      <div className="mt-4 space-y-5">
        <TagListEditor
          label="Systems"
          hint="Software or hardware the ticket relates to (Salesforce, Outlook, VPN, Printer, etc.)"
          values={settings.systems || []}
          setValues={(next) => setSettings((s) => ({ ...s, systems: next }))}
          onRename={renameFor("systems")}
          testid="tag-systems"
          disabled={!isAdmin}
        />
        <TagListEditor
          label="Issue types"
          hint="High-level categories of failure (Login Error, Crash, Connectivity, etc.)"
          values={settings.issue_types || []}
          setValues={(next) => setSettings((s) => ({ ...s, issue_types: next }))}
          onRename={renameFor("issue_types")}
          testid="tag-issue-types"
          disabled={!isAdmin}
        />
      </div>
      <div className="mt-3 text-[11px] text-slate-500 font-mono">
        Priorities are fixed (low/medium/high/urgent) so SLA math and colour coding stay consistent.
      </div>
    </div>
  );
}
